import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { post } from './util'
import Button from './components/Button'
import logo from './logo.png'

const itmsServicesUrl = 'itms-services://?action=download-manifest&url=https://dl.nssurge.com/ios/enterprise/manifest.plist'

const InstallLogin = () => {
  const [companyID, setCompanyID] = useState('')
  const [userID, setUserID] = useState('')
  const [passcode, setPasscode] = useState('')
  const [loading, setLoading] = useState(false)
  const [redirecting, setRedirecting] = useState(false)

  const handleSubmit = e => {
    e.preventDefault()
    setLoading(true)
    post('portal/install-user-login', { companyID, userID, passcode })
      .then(ret => {
        setLoading(false)

        if (ret.error || !ret.success) {
          alert(ret.error)
          return
        }

        setRedirecting(true)
        window.location.href = itmsServicesUrl
      })
      .catch(e => {
        setLoading(false)
        alert(e.message)
      })
  }

  if (redirecting) {
    return (
      <div className='text-view pt-running-text'>
        <ul className='pt-breadcrumbs'>
          <li><Link className='pt-breadcrumb' to='/'>Home</Link></li>
          <li><Link className='pt-breadcrumb' to='/install'>Install Guide</Link></li>
          <li><span className='pt-breadcrumb pt-breadcrumb-current'>Sign In</span></li>
        </ul>
        <p className='text-slate-600 text-sm'>
          Redirecting to install… If nothing happens,{' '}
          <a className='text-blue-600 underline' href={itmsServicesUrl}>tap here to continue</a>.
        </p>
      </div>
    )
  }

  return (
    <div className='min-h-screen bg-surface flex items-center justify-center px-4'>
      <div className='w-full max-w-md rounded-[32px] border border-slate-200 shadow-soft bg-white p-8 space-y-6'>
        <div className='flex items-center justify-between'>
          <div>
            <p className='text-2xl font-semibold text-ink'>Surge Enterprise</p>
            <p className='text-sm text-slate-500'>Sign in to continue installation.</p>
          </div>
          <img src={logo} alt='Logo' width='48' height='48' />
        </div>
        <form className='space-y-4' onSubmit={handleSubmit}>
          <div>
            <label className='text-sm font-medium text-slate-600'>Company ID</label>
            <input
              value={companyID}
              onChange={e => setCompanyID(e.target.value)}
              className='mt-1 w-full rounded-2xl border border-slate-200 px-4 py-2.5 focus:border-ink focus:ring-1 focus:ring-ink'
            />
          </div>
          <div>
            <label className='text-sm font-medium text-slate-600'>User ID</label>
            <input
              value={userID}
              onChange={e => setUserID(e.target.value)}
              className='mt-1 w-full rounded-2xl border border-slate-200 px-4 py-2.5 focus:border-ink focus:ring-1 focus:ring-ink'
            />
          </div>
          <div>
            <label className='text-sm font-medium text-slate-600'>Passcode</label>
            <input
              type='password'
              value={passcode}
              onChange={e => setPasscode(e.target.value)}
              className='mt-1 w-full rounded-2xl border border-slate-200 px-4 py-2.5 focus:border-ink focus:ring-1 focus:ring-ink'
            />
          </div>
          <Button type='submit' className='w-full justify-center' disabled={loading}>
            {loading ? 'Checking…' : 'Sign In'}
          </Button>
        </form>
      </div>
    </div>
  )
}

export default InstallLogin
